import { useEffect } from 'react';
import { ConfiguredCarTechnicalDataDialogContent } from '~/app/pages/configurator/components/technical-data-dialog/components/technical-data-dialog-content';
import { DialogProps } from '~/app/pages/summary/dialogs/dialog-props';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { Dialog } from '~/components/dialog';
import { useCatalog, useConfigurator } from '~/graphql/hooks/use-configurator';

export function TechnicalDataDialog({ open, onClose }: DialogProps) {
	const { carIdentifier } = useConfigurator();
	const { trimlines } = useCatalog();
	const driveTrain = trimlines?.flatMap((t) => t.driveTrains)?.find((d) => d.status.selected);

	useEffect(() => {
		open &&
			appTrackingService.viewChangeEvent({
				eventName: 'configurator - technical data layer',
				componentName: 'technical-data-layer',
			});
	}, [open]);

	return (
		<Dialog open={open} onCloseButtonClick={onClose}>
			{driveTrain && (
				<ConfiguredCarTechnicalDataDialogContent
					carline={driveTrain.carline ?? ''}
					model={driveTrain.name}
					carIdentifier={carIdentifier}
					triggerQuery={open}
				/>
			)}
		</Dialog>
	);
}
